import { element, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { HeadingSectionProperties } from '../components/heading-section/heading-section-types.js';
const SectionProperties = {
    ...HeadingSectionProperties,
    icon: {
        type: oneOfType([string, element]),
    },
};
export { SectionProperties, };
//# sourceMappingURL=section-types.js.map